<template>
  <img class="playable-screenshot" :src="screenshot" />
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    }
  },
  computed: {
    screenshots() {
      return this.data.screenshots
    },
    screenshot() {
      if (!this.screenshots) return null;
      return this.screenshots['1280_720']
    },
  }
}
</script>

<style scoped>
  .playable-screenshot {
    width: 128px;
    height: 72px;
    margin-right: 20px;
  }

  @media all and (max-width: 500px){
    .playable-screenshot {
      width: 99px;
      height: 50px;
    }
  }
</style>
